<template>
    <v-container>
        <!-- TODO: Pulling transcripts. Need to fold into schedules when (or if) ready -->
        <!-- <h1>Transcripts</h1>
        <table>
            <tr v-for="transcript in this.transcripts" v-bind:key="transcript.id">
                <td>{{ transcript.id}}</td>
                <td>{{ transcript.term }}</td>
            </tr>
        </table> -->
        <h1>Courses</h1>
        <!-- <p>{{ this.terms }}</p> -->
        <div class="typography" v-if="courseLoadState === 'loaded'">
            <!-- <p>Select your desired term to view course information.</p> -->
            <div class="table_wrapper">
                <div class="table_wrapper_inner">
                    <table>
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>ID</th>
                                <th>Meeting Times</th>
                                <!-- <th>Instructor</th> -->
                                <th>Credits</th>
                                <th>Grades</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(section, index) in this.sections" v-bind:key="section.id">
                                <td>{{ section.title }}</td>
                                <td>{{ section.id }}</td>
                                <td>{{ section.days_of_week }}</td>
                                <!-- <td>Pierone</td> -->
                                <td>{{ credits[index] }}</td>
                                <td>{{ grades[index] }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <hr />
            <p>Classrooms and faculty are subject to change. Please check back before the beginning of classes.</p>

        </div>

        <div v-else-if="courseLoadState === 'error'">
            <p><strong>There are no courses that match your record.</strong> If you are enrolled in the College Credit
                Advantage Program, please contact <a href="mailto:ccap@adelphi.edu">ccap@adelphi.edu</a>.</p>
        </div>
        <div v-else>
            <v-skeleton-loader class="mx-auto" type="table-body, table-row-divider@6"></v-skeleton-loader>
        </div>
    </v-container>
</template>
<script>


export default {
    // props: {
    //     terms: [],
    //     sections: []
    // },

    data: () => ({
        // sections: []
        full_course_list: [],
        courseLoadState: 'loading'
    }),

    mounted() {
        // Fetch Transcripts (Grades)
        // this.$store.dispatch('fetchStudentTranscripts', '1902460')
        //     .then((resp => {
        //         window.console.log("TRANSCRIPT RESPONSE")
        //         window.console.log(this.transcripts)
        //         window.console.log(resp)
        //     }))
        
        // Fetch Student Terms (Roster / Schedule)
        this.$store.dispatch('fetchStudentTerms')
            .then(() => {
                // window.console.log("RESPONSE: "+JSON.stringify(resp.data))
                //   for (var i = 0; i < resp.data.length; i++) {
                //       window.console.log('TERMS ' + resp.data[i])
                //       window.console.log('CREDIT: ' + this.credits[i])
                //   }

                // window.console.log('CREDITS: ' + this.credits)
                this.$store.dispatch('fetchStudentSections')
                    .then(() => {
                        // window.console.log('SECTIONS: '+this.sections.length)

                        this.$store.dispatch('fetchCourseCalendars')
                            .then(() => {
                                // window.console.log("CALENDARS COUNT: "+this.calendars.length)
                                for (var i = 0; i < this.calendars.length; i++) {
                                    // window.console.log("Calendar: "+this.calendars[i])
                                }
                                this.courseLoadState = 'loaded'
                            })
                            .catch(() => { this.courseLoadState = 'error' })
                    })
                    .catch(() => { this.courseLoadState = 'error' })
            })
            .catch(() => { this.courseLoadState = 'error' })
    },

    computed: {
        sections: function () {
            return this.$store.getters.sections
        },
        transcripts: function () {
            return this.$store.getters.transcripts
        },
        calendars: function () {
            return this.$store.getters.calendars
        },
        credits: function () {
            return this.$store.getters.credits
        },
        grades: function () {
            return this.$store.getters.grades
        }
    }
}
</script>
